<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.moeda.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.moeda.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'parametros.moeda.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-5"
              label="{{'parametros.moeda.cadastro.dadosPrincipais.ano' | translate}}" name="ano"
              [(ngModel)]="model.ano" obrigatorio="true" required
              placeholder="{{'parametros.moeda.cadastro.dadosPrincipais.anoPlaceHolder' | translate}}">
            </app-text-box>
            <app-dropdown-list [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.moeda.cadastro.dadosPrincipais.mes' | translate}}" name="tipoDealer"
              [(ngModel)]="model.mes" required [itens]="meses"></app-dropdown-list>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-10"
              label="{{'parametros.moeda.cadastro.dadosPrincipais.valor' | translate}}"
              name="valor_previsao" appFormatCurrency [(ngModel)]="model.valor" obrigatorio="true" required
              placeholder="0..." #inputValor (keyup)="model.valor=$event.target.value">
            </app-text-box>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
